// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumPublishStatus } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPublishStatus';
import { EnumPublishType } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPublishType';
import { EnumDeployType } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumDeployType';
/**
 * 发布记录 实体类
 * 发布记录
 */
export class PublishHistoryRecord extends BaseEntity {
  /** 总任务Id : 总任务Id */
  private _taskId: string;

  /** 设置：总任务Id */
  public get taskId() {
    return this._taskId;
  }

  /** 获取：总任务Id */
  public set taskId(value: string) {
    this._taskId = value;
  }

  /** 发布状态 : 发布状态 */
  private _publishStatus: EnumPublishStatus;

  /** 设置：发布状态 */
  public get publishStatus() {
    return this._publishStatus;
  }

  /** 获取：发布状态 */
  public set publishStatus(value: EnumPublishStatus) {
    this._publishStatus = value;
  }

  /** 工作区间名称 : 工作区间名称 */
  private _workSpaceName: string;

  /** 设置：工作区间名称 */
  public get workSpaceName() {
    return this._workSpaceName;
  }

  /** 获取：工作区间名称 */
  public set workSpaceName(value: string) {
    this._workSpaceName = value;
  }

  /** 产品名称 : 产品名称 */
  private _productName: string;

  /** 设置：产品名称 */
  public get productName() {
    return this._productName;
  }

  /** 获取：产品名称 */
  public set productName(value: string) {
    this._productName = value;
  }

  /** 应用名称 : 应用名称 */
  private _appName: string;

  /** 设置：应用名称 */
  public get appName() {
    return this._appName;
  }

  /** 获取：应用名称 */
  public set appName(value: string) {
    this._appName = value;
  }

  /** 应用唯一标识 : 应用唯一标识 */
  private _appKey: string;

  /** 设置：应用唯一标识 */
  public get appKey() {
    return this._appKey;
  }

  /** 获取：应用唯一标识 */
  public set appKey(value: string) {
    this._appKey = value;
  }

  /** 文件存储地址 : 文件存储地址 */
  private _fileUrl: string;

  /** 设置：文件存储地址 */
  public get fileUrl() {
    return this._fileUrl;
  }

  /** 获取：文件存储地址 */
  public set fileUrl(value: string) {
    this._fileUrl = value;
  }

  /** 工作的流水线Id : 工作的流水线Id */
  private _pipeLineId: number;

  /** 设置：工作的流水线Id */
  public get pipeLineId() {
    return this._pipeLineId;
  }

  /** 获取：工作的流水线Id */
  public set pipeLineId(value: number) {
    this._pipeLineId = value;
  }

  /** 流水线次数编号 : 流水线次数编号 */
  private _builderNumber: number;

  /** 设置：流水线次数编号 */
  public get builderNumber() {
    return this._builderNumber;
  }

  /** 获取：流水线次数编号 */
  public set builderNumber(value: number) {
    this._builderNumber = value;
  }

  /** 发布编号 : 发布编号 */
  private _groupId: string;

  /** 设置：发布编号 */
  public get groupId() {
    return this._groupId;
  }

  /** 获取：发布编号 */
  public set groupId(value: string) {
    this._groupId = value;
  }

  /** 发布类型 : 发布类型 */
  private _publishType: EnumPublishType;

  /** 设置：发布类型 */
  public get publishType() {
    return this._publishType;
  }

  /** 获取：发布类型 */
  public set publishType(value: EnumPublishType) {
    this._publishType = value;
  }

  /** nacos的名空间Id : nacos的名空间Id */
  private _nameSpaceId: string;

  /** 设置：nacos的名空间Id */
  public get nameSpaceId() {
    return this._nameSpaceId;
  }

  /** 获取：nacos的名空间Id */
  public set nameSpaceId(value: string) {
    this._nameSpaceId = value;
  }

  /** db帐号 : db帐号 */
  private _dBUserName: string;

  /** 设置：db帐号 */
  public get dBUserName() {
    return this._dBUserName;
  }

  /** 获取：db帐号 */
  public set dBUserName(value: string) {
    this._dBUserName = value;
  }

  /** db密码 : db密码 */
  private _dBSecrect: string;

  /** 设置：db密码 */
  public get dBSecrect() {
    return this._dBSecrect;
  }

  /** 获取：db密码 */
  public set dBSecrect(value: string) {
    this._dBSecrect = value;
  }

  /** 后端应用根名空间 : 后端应用根名空间 */
  private _rootNameSpace: string;

  /** 设置：后端应用根名空间 */
  public get rootNameSpace() {
    return this._rootNameSpace;
  }

  /** 获取：后端应用根名空间 */
  public set rootNameSpace(value: string) {
    this._rootNameSpace = value;
  }

  /** 部署编号 : 部署编号(productappdesignid) */
  private _deployId: string;

  /** 设置：部署编号 */
  public get deployId() {
    return this._deployId;
  }

  /** 获取：部署编号 */
  public set deployId(value: string) {
    this._deployId = value;
  }

  /** 部署ip : 部署ip */
  private _deployIp: string;

  /** 设置：部署ip */
  public get deployIp() {
    return this._deployIp;
  }

  /** 获取：部署ip */
  public set deployIp(value: string) {
    this._deployIp = value;
  }

  /** 部署端口号 : 部署端口号 */
  private _deployPort: string;

  /** 设置：部署端口号 */
  public get deployPort() {
    return this._deployPort;
  }

  /** 获取：部署端口号 */
  public set deployPort(value: string) {
    this._deployPort = value;
  }

  /** 部署类型 : 部署类型 */
  private _deployType: EnumDeployType;

  /** 设置：部署类型 */
  public get deployType() {
    return this._deployType;
  }

  /** 获取：部署类型 */
  public set deployType(value: EnumDeployType) {
    this._deployType = value;
  }

  constructor() {
    super();
    this._taskId = '';
    this._publishStatus = EnumPublishStatus.Pendding;
    this._workSpaceName = '';
    this._productName = '';
    this._appName = '';
    this._appKey = '';
    this._fileUrl = '';
    this._pipeLineId = 0;
    this._builderNumber = 0;
    this._groupId = '';
    this._publishType = EnumPublishType.Backend;
    this._nameSpaceId = '';
    this._dBUserName = '';
    this._dBSecrect = '';
    this._rootNameSpace = '';
    this._deployId = '';
    this._deployIp = '';
    this._deployPort = '';
    this._deployType = EnumDeployType.Cloud;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PublishHistoryRecord, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.taskId = element.taskId;
      this.publishStatus = element.publishStatus;
      this.workSpaceName = element.workSpaceName;
      this.productName = element.productName;
      this.appName = element.appName;
      this.appKey = element.appKey;
      this.fileUrl = element.fileUrl;
      this.pipeLineId = element.pipeLineId;
      this.builderNumber = element.builderNumber;
      this.groupId = element.groupId;
      this.publishType = element.publishType;
      this.nameSpaceId = element.nameSpaceId;
      this.dBUserName = element.dBUserName;
      this.dBSecrect = element.dBSecrect;
      this.rootNameSpace = element.rootNameSpace;
      this.deployId = element.deployId;
      this.deployIp = element.deployIp;
      this.deployPort = element.deployPort;
      this.deployType = element.deployType;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.taskId = json.TaskId;
    this.publishStatus = json.PublishStatus as EnumPublishStatus;
    this.workSpaceName = json.WorkSpaceName;
    this.productName = json.ProductName;
    this.appName = json.AppName;
    this.appKey = json.AppKey;
    this.fileUrl = json.FileUrl;
    this.pipeLineId = json.PipeLineId;
    this.builderNumber = json.BuilderNumber;
    this.groupId = json.GroupId;
    this.publishType = json.PublishType as EnumPublishType;
    this.nameSpaceId = json.NameSpaceId;
    this.dBUserName = json.DBUserName;
    this.dBSecrect = json.DBSecrect;
    this.rootNameSpace = json.RootNameSpace;
    this.deployId = json.DeployId;
    this.deployIp = json.DeployIp;
    this.deployPort = json.DeployPort;
    this.deployType = json.DeployType as EnumDeployType;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.TaskId = this.taskId;
    json.PublishStatus = this.publishStatus;
    json.WorkSpaceName = this.workSpaceName;
    json.ProductName = this.productName;
    json.AppName = this.appName;
    json.AppKey = this.appKey;
    json.FileUrl = this.fileUrl;
    json.PipeLineId = this.pipeLineId;
    json.BuilderNumber = this.builderNumber;
    json.GroupId = this.groupId;
    json.PublishType = this.publishType;
    json.NameSpaceId = this.nameSpaceId;
    json.DBUserName = this.dBUserName;
    json.DBSecrect = this.dBSecrect;
    json.RootNameSpace = this.rootNameSpace;
    json.DeployId = this.deployId;
    json.DeployIp = this.deployIp;
    json.DeployPort = this.deployPort;
    json.DeployType = this.deployType;
  }

  static Create(json: any): PublishHistoryRecord {
    const publishHistoryRecord = new PublishHistoryRecord();
    publishHistoryRecord.Deserialize(json);
    publishHistoryRecord.json = json;
    return publishHistoryRecord;
  }
}
